import styled from 'styled-components';
import { rgba } from 'polished';
import { white, primary, neutral, info, warning } from '../../../style/colors';

export const DeliveryInfoContainer = styled.div`
  background-color: ${info.light};
  border-left: 3px solid ${info.base};
  padding: 10px 14px;
  margin-bottom: 8px;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  gap: 12px;

  > i {
    font-size: 18px;
    color: ${info.base};
    margin-top: 2px;
  }
`;

export const DeliveryText = styled.div`
  font-size: 11px;
  color: ${neutral[700]};

  strong {
    color: ${info.dark};
    font-weight: 600;
  }
`;

export const DeliveryScheduleWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DeliveryScheduleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DeliveryScheduleTitle = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: ${info.dark};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const DeliveryScheduleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DeliveryScheduleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${info.base};
  font-weight: 500;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 4px;

  .quantity {
    font-weight: 700;
    min-width: 20px;
    color: ${info.dark};
  }

  .separator {
    color: ${neutral[300]};
  }

  .date {
    font-weight: 600;
    color: ${info.dark};
  }
`;

export const RefreshButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${info.base};
  font-size: 14px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: ${rgba(info.base, 0.1)};
    transform: rotate(180deg);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  &.spinning i {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

export const ErrorMessage = styled.div`
  background-color: ${warning.light};
  border-left: 3px solid ${warning.base};
  padding: 6px 10px;
  margin-bottom: 8px;
  border-radius: 3px;
  color: ${warning.dark};
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 8px;

  i { font-size: 16px; }
`;

export const CalendarIconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  margin-left: 8px;
  color: ${primary[500]};
  font-size: 20px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: ${rgba(primary[500], 0.1)};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  i { font-size: 20px; }
`;

export const DatePickerWrapper = styled.div`
  display: inline-block;
  margin-left: 4px;
`;

export const DatePickerPortal = styled.div`
  .react-datepicker {
    font-family: inherit;
    border: 2px solid ${primary[500]};
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    background: ${white};
  }

  .react-datepicker__header {
    background: ${primary[500]};
    border-bottom: none;
    border-radius: 6px 6px 0 0;
    padding-top: 12px;
  }

  .react-datepicker__current-month {
    color: ${white};
    font-weight: 600;
  }

  .react-datepicker__day-name {
    color: ${neutral[700]};
    font-weight: 700;
  }

  .react-datepicker__day {
    color: ${neutral[700]};
    border-radius: 4px;
    transition: all 0.2s ease;
    font-weight: 500;

    &:hover {
      background: ${rgba(primary[500], 0.1)};
      color: ${primary[500]};
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: ${primary[500]};
    color: ${white};
    font-weight: 600;

    &:hover {
      background: ${primary[600]};
    }
  }

  .react-datepicker__day--disabled {
    color: ${neutral[300]};
    cursor: not-allowed;
    text-decoration: line-through;
    opacity: 0.5;

    &:hover {
      background: transparent;
      color: ${neutral[300]};
    }
  }

  .react-datepicker__navigation {
    top: 8px;
  }

  .react-datepicker__navigation-icon::before {
    border-color: ${white};
  }

  .react-datepicker__navigation:hover *::before {
    border-color: ${rgba(white, 0.8)};
  }
`;
